import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  FlowerInfoWrapper,
  Text,
  StrongText,
} from "./DashboardDetailFlowerInfoStyle";
import { useSelector } from "react-redux";
import Graph from "assets/icons/graph.svg";

const DashboardDetailFlowerInfo = (props) => {
  const { f_type, f_name, pred_p, pred_b } = useParams();

  const useDashboard = useSelector(
    (state) => state.dashboard?.searchList?.data
  );

  function MarketBuyability() {
    switch (pred_b) {
      case "0":
        return "낮음";
      case "1":
        return "평균";
      case "2":
        return "높음";
      default:
        return "";
    }
  }
  return (
    <FlowerInfoWrapper>
      {props.nameSearch === true ? (
        <>
          <div>
            <Text>{useDashboard.f_type}</Text>
            <Text>{`시장 구매 가능성 ${MarketBuyability()}`}</Text>
          </div>
          <div>
            <StrongText>{useDashboard.f_name}</StrongText>
            <span>
              <Text>
                <img src={Graph} alt="Purchasability Graph" />
                AI 예측가
              </Text>
              <StrongText>
                {Number(useDashboard.pred_p).toLocaleString()}원
              </StrongText>
            </span>
          </div>
        </>
      ) : (
        <>
          <div>
            <Text>{f_type}</Text>
            <Text>{`시장 구매 가능성 ${MarketBuyability()}`}</Text>
          </div>
          <div>
            <StrongText>{f_name}</StrongText>
            <span>
              <Text>
                <img src={Graph} alt="Purchasability Graph" /> AI 예측가
              </Text>
              <StrongText>{Number(pred_p).toLocaleString()}원</StrongText>
            </span>
          </div>
        </>
      )}
    </FlowerInfoWrapper>
  );
};

export default DashboardDetailFlowerInfo;
